import { render, staticRenderFns } from "./AcompanhamentoConfiguracaoGeral.vue?vue&type=template&id=6054415a&scoped=true&"
import script from "./AcompanhamentoConfiguracaoGeral.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoConfiguracaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054415a",
  null
  
)

export default component.exports